import { FC } from "react";
import styles from "./index.module.css";
import clsx from "clsx";
import { Container } from "@mantine/core";

interface IProps {
  column?: boolean;
}

const PageBody: FC<IProps & React.ComponentProps<"div">> = props => {
  return (
    <Container
      className={clsx(styles["page-wrapper"], {
        [styles.column]: props.column
      })}
    >
      {props.children}
    </Container>
  );
};

export default PageBody;
